import { render, staticRenderFns } from "./transaction-formula-list.html?vue&type=template&id=2ad08776&scoped=true&external"
import script from "./transaction-formula-list.js?vue&type=script&lang=js&external"
export * from "./transaction-formula-list.js?vue&type=script&lang=js&external"
import style0 from "./transaction-formula-list.scss?vue&type=style&index=0&id=2ad08776&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad08776",
  null
  
)

export default component.exports